import { kebabCase } from "lodash";

export function createSlug(value: string, ...prefixes: string[]): string {
  return kebabCase([...(prefixes ?? []), value].join(" "));
}
